import { RouteRecordRaw } from 'vue-router';

const adminRoutes: RouteRecordRaw[] = [
  {
    path: 'admin',
    name: 'SystemAdminView',
    redirect: { name: 'SystemAdminCraftsmanPlus' },
    meta: { menu: 'systemAdmin' },
    component: () => import(/* webpackChunkName: "AdminView" */ '@/views/admin/AdminView.vue'),
    children: [
      {
        path: 'users',
        name: 'SystemAdminCraftsmanPlus',
        component: () => import(/* webpackChunkName: "AdminCraftsmanView" */ '@/views/admin/AdminCraftsmanView.vue'),
      },
      {
        path: 'companies/deleted',
        name: 'SystemAdminDeletedCompanies',
        component: () => import(/* webpackChunkName: "AdminDeletedCompanies" */ '@/views/admin/AdminDeletedCompanies.vue'),
      },
      {
        path: 'users/deleted',
        name: 'SystemAdminDeletedUsers',
        component: () => import(/* webpackChunkName: "AdminDeletedUsers" */ '@/views/admin/AdminDeletedUsers.vue'),
      },
      {
        path: 'games',
        name: 'SystemAdminGames',
        component: () => import(/* webpackChunkName: "SystemAdminGames" */ '@/views/admin/AdminGames.vue'),
      },
    ],
  },
];

export default adminRoutes;
